import {
  EfsMelcoEfsModelsSchemaListItem,
  VerticalForm,
  DebugForm,
} from "melco-shared-logic";
import { useAdvancedOptions } from "../../hooks/settings/useAdvancedOptions";
import { AddOrSaveButton } from "../inputFormats/AddOrSaveButton";
import { DynamicFilenameRule } from "../inputFormats/DynamicFilenameRule";
import { FoldernameRuleFormMode } from "./FoldernameRuleDrawer";
import { SelectFoldernameRuleType } from "./SelectFoldernameRuleType";
import { StaticFoldernameRule } from "./StaticFoldernameRule";

type DisplayFoldernameRuleFormProps = {
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
  formMode: FoldernameRuleFormMode;
  isAddingNewRule: boolean;
};

export const DisplayFoldernameRuleForm: React.FC<
  DisplayFoldernameRuleFormProps
> = ({ dataAssignments, formMode, isAddingNewRule }) => {
  const isAdvancedOptionsEnabled = useAdvancedOptions();

  return (
    <VerticalForm>
      <SelectFoldernameRuleType isDisabled={!isAddingNewRule} />

      <DynamicFilenameRule
        isAdvancedOptionsEnabled={isAdvancedOptionsEnabled}
        dataAssignments={dataAssignments}
        sourceModifierName="reg_expression_id"
      />

      <StaticFoldernameRule />

      <AddOrSaveButton formMode={formMode} />

      {false && <DebugForm />}
    </VerticalForm>
  );
};
